import React, { useEffect, useState } from 'react';
import styles from './Home.module.scss';
import PageTitle from '../../../components/pageTitle/PageTitle';
import DashboardDirectorCard from '../../../components/dashboardDirectorCard/DashboardDirectorCard';
import LoadingOverlay from '../../../components/loadingOverlay/LoadingOverlay';
import axiosClient from '../../../api/axiosClient';
import { useToasts } from '../../../contexts/ToastContext';

const ApplicationAdminHome = () => {
  const { showToast } = useToasts();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axiosClient.get('/dashboard/super-admin');
        setData(response.data || {});
      } catch (error) {
        showToast(error.message, 'error');
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [showToast]);

  const { subscriptions, programs, users, evaluationsPendingReview } = data || {};

  return (
    <>
      {isLoading && <LoadingOverlay />}
      <div className={styles.header}>
        <PageTitle label="Dashboard" />
      </div>
      <div className={styles.container}>

        <h3 className={styles.sectionTitle}>Subscriptions</h3>
        <div className={styles.cardGrid}>
          <DashboardDirectorCard title="Total Subscriptions" type="Blue" count={{ count: subscriptions?.total ?? 0 }} />
          <DashboardDirectorCard title="Active Subscriptions" type="Blue Light" count={{ count: subscriptions?.active ?? 0 }} />
          <DashboardDirectorCard title="Trial Subscriptions" type="Blue" count={{ count: subscriptions?.trial ?? 0 }} />
        </div>

        <h3 className={styles.sectionTitle}>Programs</h3>
        <div className={styles.cardGrid}>
          <DashboardDirectorCard title="Total Programs" type="Blue Light" count={{ count: programs?.total ?? 0 }} />
          <DashboardDirectorCard title="Active Programs" type="Blue" count={{ count: programs?.active ?? 0 }} />
        </div>

        <h3 className={styles.sectionTitle}>Users</h3>
        <div className={styles.cardGrid}>
          <DashboardDirectorCard title="Total Users" type="Blue" count={{ count: users?.total ?? 0 }} showIcon />
          <DashboardDirectorCard title="Students" type="Blue Light" count={{ count: users?.students ?? 0 }} showIcon />
          <DashboardDirectorCard title="Instructors" type="Blue" count={{ count: users?.instructors ?? 0 }} showIcon />
          <DashboardDirectorCard title="Program Directors" type="Blue Light" count={{ count: users?.programDirectors ?? 0 }} showIcon />
          <DashboardDirectorCard title="Program Admins" type="Blue" count={{ count: users?.programAdmins ?? 0 }} showIcon />
          <DashboardDirectorCard title="Coordinators" type="Blue Light" count={{ count: users?.coordinators ?? 0 }} showIcon />
        </div>

        <h3 className={styles.sectionTitle}>Evaluations</h3>
        <div className={styles.cardGrid}>
          <DashboardDirectorCard
            title="Pending Review"
            type="Blue"
            count={{ count: evaluationsPendingReview ?? 0, showIcon: true }}
          />
        </div>

      </div>
    </>
  );
};

export default ApplicationAdminHome;
